/* eslint-disable no-return-assign */
/* eslint-disable react/no-unknown-property */
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import c from 'classnames'

const PauseIcon = props => (
  <svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M10 4H6V20H10V4Z' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
    <path d='M18 4H14V20H18V4Z' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
)

const PlayIcon = props => (
  <svg {...props} width='16' height='20' viewBox='0 0 16 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M1 1L15 10L1 19V1Z' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' />
  </svg>
)

const PlaybackButton = ({ playbackStatus, onClick, progress, setPlayAudio, playAudio, setPlay, checkedPodcast, audio }) => {
  const { audioState } = useSelector(({ audio }) => audio)
  useEffect(() => {
    if (+progress === 100) {
      onClick()
      setPlayAudio(false)
    }
  }, [progress])

  useEffect(() => {
    if (audioState?.podcast?.podcast?.uuid && !audioState?.status) {
      checkedPodcast()
    }
  }, [audioState])

  return (
    <div
      onClick={() => {
        onClick()
      }}
      className={c('playback-button', audioState?.status && audio === audioState?.src && 'playback-button-active')}
    >
      {audioState?.src === audio ? (
        audioState?.status ? <PauseIcon /> : <PlayIcon />
      ) : (
        <PlayIcon />
      )}
    </div>
  )
}

export default PlaybackButton
